export default __webpack_public_path__ + "static/media/icon-app-hosting.e8da39cb.svg";